module.exports = __webpack_public_path__ + "img/icon_return_goods.e76b9626.png";